import { Pipe, PipeTransform } from '@angular/core';

import {
  anyFnExec,
  GridColumn,
  GridOptions,
  IIdentity,
  TooltipContext,
} from '../models';

@Pipe({
  name: 'tooltipDisabled',
})
export class TooltipDisabledPipe<T extends IIdentity> implements PipeTransform {
  transform(
    // The cell's own value: re-runs the pipe when the row is edited in place
    _message: string,
    data: T,
    column: GridColumn<T>,
    options: GridOptions<T>,
    // Bumped by refreshSelectableRows(), which repaintRows() also runs: re-runs the pipe when state outside this cell changes
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _revision?: number
  ): boolean {
    const context: TooltipContext<T> = {
      data,
      columnDef: column.columnDef,
      allowEditing: options.editConfig?.allowEditing ?? true,
      allowDeleting: options.deleteConfig?.allowDeleting ?? true,
      allowDeletingRow: anyFnExec(
        options.rowConfig?.allowDeleting ?? true,
        data
      ),
    };

    // Checked before the message, which can be costly to build and is
    // pointless for a disabled tooltip.
    if (
      column.tooltip?.disabled != null &&
      anyFnExec(column.tooltip.disabled, context)
    ) {
      return true;
    }

    const tooltipMessage = column.tooltip?.message ?? data[column.columnDef];

    return !String(anyFnExec(tooltipMessage, context) ?? '');
  }
}
